export const listLocationsByAppInstance = /* GraphQL */ `
  query ListLocationsByAppInstance(
    $appInstance: String
    $mobVersion: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLocationsByAppInstance(
      appInstance: $appInstance
      mobVersion: $mobVersion
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        orderNumber
        createdAt
        updatedAt
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            orderNumber
            description
            gps
            createdAt
            updatedAt
          }
          nextToken
        }
        pointSells {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
            pointMeeting {
              id
              mobVersion
              groups
              appInstance
              mssId
              title
              description
              gps
              createdAt
              updatedAt
            }
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;

export const listPointSellsByAppInstance = /* GraphQL */ `
  query ListPointSellsByAppInstance(
    $appInstance: String
    $mobVersion: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPointSellFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPointSellsByAppInstance(
      appInstance: $appInstance
      mobVersion: $mobVersion
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        orderNumber
        addressName
        addressStreet
        addressCity
        addressPostalCode
        gps
        openHoursMondayFrom
        openHoursMondayTo
        openHoursTuesdayFrom
        openHoursTuesdayTo
        openHoursWednesdayFrom
        openHoursWednesdayTo
        openHoursThursdayFrom
        openHoursThursdayTo
        openHoursFridayFrom
        openHoursFridayTo
        openHoursSaturdayFrom
        openHoursSaturdayTo
        openHoursSundayFrom
        openHoursSundayTo
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          createdAt
          updatedAt
        }
        pointMeeting {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          gps
          createdAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;

export const listPointMeetingsByAppInstance = /* GraphQL */ `
  query ListPointMeetingsByAppInstance(
    $appInstance: String
    $mobVersion: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPointMeetingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPointMeetingsByAppInstance(
      appInstance: $appInstance
      mobVersion: $mobVersion
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        orderNumber
        gps
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          createdAt
          updatedAt
        }
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          orderNumber
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          openHoursMondayFrom
          openHoursMondayTo
          openHoursTuesdayFrom
          openHoursTuesdayTo
          openHoursWednesdayFrom
          openHoursWednesdayTo
          openHoursThursdayFrom
          openHoursThursdayTo
          openHoursFridayFrom
          openHoursFridayTo
          openHoursSaturdayFrom
          openHoursSaturdayTo
          openHoursSundayFrom
          openHoursSundayTo
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            createdAt
            updatedAt
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
          }
        }
      }
      nextToken
    }
  }
`;

export const listRentCategoriesByProductType = /* GraphQL */ `
  query ListRentCategoriesByProductType(
    $appInstance: String
    $mobVersion: Int
    $productType: ProductType
  ) {
    listCategoriesByProductType(
      appInstance: $appInstance
      mobVersionProductType: {
        eq: { mobVersion: $mobVersion, productType: $productType }
      }
    ) {
      items {
        title
        description
        orderNumber
        campCourse
        mssId
        hidden
        products {
          items {
            id
            mssId
            mobVersion
            title
            description
            intro
            campCourse
            orderNumber
            rentProductType
            hidden
            rentAllowedLengths {
              length
              unit
            }
            rentAvailabilityMode
            pricingMode
            images
            sizes
            deposit
            schoolFormType
            masterProduct {
              id
              mobVersion
              groups
              appInstance
              mssId
              title
              description
              intro
              campCourse
              productType
              enabledFrom
              enabledTo
              pricingMode
              numberOfPersons
              minNumOfPersons
              maxNumOfPersons
              schoolFormType
              priceTables {
                numberOfPersons
                priceListType
                isLowSeason
                dphPercent
                price05
                price1
                price2
                price3
                price4
                price5
                price6
                price7
                price8
                price9
                price10
                price11
                price12
                price13
                price14
                price15
                price16
                price17
                price18
                price19
                price20
                price1_5
                price2_5
                price3_5
                price4_5
                price5_5
                price6_5
                price7_5
                price8_5
                price9_5
                price10_5
                price11_5
                price12_5
                price13_5
                price14_5
                price15_5
                price16_5
                price17_5
                price18_5
                price19_5
                price20_5
                priceEveryOther
              }
            }
            childProducts {
              items {
                id
                mobVersion
                groups
                appInstance
                mssId
                title
                description
                intro
                campCourse
                productType
                enabledFrom
                enabledTo
                pricingMode
                numberOfPersons
                minNumOfPersons
                maxNumOfPersons
                schoolFormType
                priceTables {
                  numberOfPersons
                  priceListType
                  isLowSeason
                  dphPercent
                  price05
                  price1
                  price2
                  price3
                  price4
                  price5
                  price6
                  price7
                  price8
                  price9
                  price10
                  price11
                  price12
                  price13
                  price14
                  price15
                  price16
                  price17
                  price18
                  price19
                  price20
                  price1_5
                  price2_5
                  price3_5
                  price4_5
                  price5_5
                  price6_5
                  price7_5
                  price8_5
                  price9_5
                  price10_5
                  price11_5
                  price12_5
                  price13_5
                  price14_5
                  price15_5
                  price16_5
                  price17_5
                  price18_5
                  price19_5
                  price20_5
                  priceEveryOther
                }
              }
            }
            skill {
              id
              mssId
              title
              description
            }
            pointMeetings {
              items {
                pointMeeting {
                  id
                  mssId
                  title
                  description
                  orderNumber
                }
              }
            }
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            defaultLessonLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            locations {
              items {
                location {
                  id
                  mssId
                  groups
                  appInstance
                  title
                  description
                  orderNumber
                }
              }
            }
            priceTables {
              numberOfPersons
              priceListType
              isLowSeason
              dphPercent
              price05
              price1
              price2
              price3
              price4
              price5
              price6
              price7
              price8
              price9
              price10
              price11
              price12
              price13
              price14
              price15
              price16
              price17
              price18
              price19
              price20
              price1_5
              price2_5
              price3_5
              price4_5
              price5_5
              price6_5
              price7_5
              price8_5
              price9_5
              price10_5
              price11_5
              price12_5
              price13_5
              price14_5
              price15_5
              price16_5
              price17_5
              price18_5
              price19_5
              price20_5
              priceEveryOther
            }
            sets {
              items {
                set {
                  id
                  title
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const getProduct = /* GraphQL */ `
  query GetProduct($id: ID!) {
    getProduct(id: $id) {
      id
      mobVersion
      mssId
      title
      description
      intro
      campCourse
      category {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        productType
        orderNumber
        campCourse
        hidden
      }
      orderNumber
      appInstance
      images
      sizes
      deposit
      rentProductType
      hidden
      rentAllowedLengths {
        length
        unit
      }
      rentAvailabilityMode
      pricingMode
      masterProduct {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        intro
        productType
        enabledFrom
        enabledTo
        pricingMode
        numberOfPersons
        minNumOfPersons
        maxNumOfPersons
        rentAvailabilityMode
        childProducts {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            intro
            productType
            enabledFrom
            enabledTo
            pricingMode
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            rentAvailabilityMode
          }
        }
      }
      childProducts {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          intro
          productType
          enabledFrom
          enabledTo
          pricingMode
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          rentAvailabilityMode
        }
      }
      skill {
        id
        mssId
        title
        description
      }
      pointMeetings {
        items {
          pointMeeting {
            id
            mssId
            title
            description
            orderNumber
          }
        }
      }
      schoolFormType
      schoolAgeGroups
      schoolSkillLevelClients
      numberOfPersons
      minNumOfPersons
      maxNumOfPersons
      minLessonLength
      maxLessonLength
      minLength
      maxLength
      minDailyLength
      maxDailyLength
      defaultDailyLength
      allowGroupCourseFlexibleStart
      groupCourseCustomLessonSelection
      defaultLessonLength
      timePreferencesStartTimes
      timePreferencesEnabledMonday
      timePreferencesEnabledTuesday
      timePreferencesEnabledWednesday
      timePreferencesEnabledThursday
      timePreferencesEnabledFriday
      timePreferencesEnabledSaturday
      timePreferencesEnabledSunday
      priceTables {
        numberOfPersons
        priceListType
        isLowSeason
        dphPercent
        price05
        price1
        price2
        price3
        price4
        price5
        price6
        price7
        price8
        price9
        price10
        price11
        price12
        price13
        price14
        price15
        price16
        price17
        price18
        price19
        price20
        price1_5
        price2_5
        price3_5
        price4_5
        price5_5
        price6_5
        price7_5
        price8_5
        price9_5
        price10_5
        price11_5
        price12_5
        price13_5
        price14_5
        price15_5
        price16_5
        price17_5
        price18_5
        price19_5
        price20_5
        priceEveryOther
      }
      sets {
        items {
          id
          set {
            id
            title
            products {
              items {
                product {
                  id
                  title
                  description
                  intro
                  orderNumber
                  images
                  rentAvailabilityMode
                  rentProductType
                  hidden
                  rentAllowedLengths {
                    length
                    unit
                  }
                  pricingMode
                }
              }
            }
            priceTables {
              priceListType
              numberOfPersons
              isLowSeason
              dphPercent
              price05
              price1
              price2
              price3
              price4
              price5
              price6
              price7
              price8
              price9
              price10
              price11
              price12
              price13
              price14
              price15
              price16
              price17
              price18
              price19
              price20
              price1_5
              price2_5
              price3_5
              price4_5
              price5_5
              price6_5
              price7_5
              price8_5
              price9_5
              price10_5
              price11_5
              price12_5
              price13_5
              price14_5
              price15_5
              price16_5
              price17_5
              price18_5
              price19_5
              price20_5
              priceEveryOther
            }
          }
          product {
            id
            title
            description
            intro
            orderNumber
            sizes
            deposit
            images
            rentProductType
            hidden
            rentAllowedLengths {
              length
              unit
            }
            rentAvailabilityMode
            pricingMode
            masterProduct {
              id
              mobVersion
              groups
              appInstance
              mssId
              title
              description
              intro
              productType
              enabledFrom
              enabledTo
              pricingMode
              rentAvailabilityMode
            }
          }
        }
      }
    }
  }
`;

// nepouziva se
export const getSet = /* GraphQL */ `
  query GetSet($id: ID!) {
    getSet(id: $id) {
      id
      mobVersion
      title
      priceTables {
        numberOfPersons
        priceListType
        isLowSeason
        dphPercent
        price05
        price1
        price2
        price3
        price4
        price5
        price6
        price7
        price8
        price9
        price10
        price11
        price12
        price13
        price14
        price15
        price16
        price17
        price18
        price19
        price20
        price1_5
        price2_5
        price3_5
        price4_5
        price5_5
        price6_5
        price7_5
        price8_5
        price9_5
        price10_5
        price11_5
        price12_5
        price13_5
        price14_5
        price15_5
        price16_5
        price17_5
        price18_5
        price19_5
        price20_5
        priceEveryOther
      }
      products {
        items {
          product {
            id
            title
            description
            intro
            orderNumber
            sizes
            deposit
            rentProductType
            hidden
            rentAllowedLengths {
            length
            unit
          }
            rentAvailabilityMode
            pricingMode
          }
        }
      }
    }
  }
`;

export const getOrderr = /* GraphQL */ `
  query GetOrderr($id: ID!) {
    getOrderr(id: $id) {
      id
      orderrNumber
      language
      discountCode
      mobVersion
      price
      priceWithoutDph
      dph
      rentDiscountPercent
      schoolDiscountPercent
      itemsCount
      expireAt
      createdAt
      updatedAt
      bookingState
      groups
      datePickUp
      dateReturn
      dateTryOut
      paymentMethod
      appInstance
      client {
        id
        groups
        appInstance
        mssId
        cognitoId
        name
        surname
        age
        gender
        email
        phone
        documentType
        documentNumber
        documentValidTo
        companyName
        ic
        dic
      }
      pointSell {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        orderNumber
        addressName
        addressStreet
        addressCity
        addressPostalCode
        gps
        openHoursMondayFrom
        openHoursMondayTo
        openHoursTuesdayFrom
        openHoursTuesdayTo
        openHoursWednesdayFrom
        openHoursWednesdayTo
        openHoursThursdayFrom
        openHoursThursdayTo
        openHoursFridayFrom
        openHoursFridayTo
        openHoursSaturdayFrom
        openHoursSaturdayTo
        openHoursSundayFrom
        openHoursSundayTo
        createdAt
        updatedAt
      }
      payments {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          paymentMethod
          paymentState
          amount
          currency
          transId
          redirectUrl
          createdAt
          updatedAt
        }
        nextToken
      }
      orderrItemGroups {
        items {
          id
          groups
          appInstance
          mssId
          itemsCount
          description
          numberOfPersons
          length
          priceListType
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          dph
          dphPercent
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            orderNumber
            gps
            createdAt
            updatedAt
          }
          orderr {
            id
            price
          }
          subjectProfiles {
            name
            surname
            shoeSize
            rentAbilityLevel
            gender
            age
            weight
            height
            note
            schoolSkillLevelClient
            language
          }
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            intro
            orderNumber
            productType
            pricingMode
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            hidden
            rentAllowedLengths {
              length
              unit
            }
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            allowGroupCourseFlexibleStart
            groupCourseCustomLessonSelection
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          set {
            id
            title
            description
          }
          orderrItems {
            items {
              id
              language
              languages
              skillLevelClient
              sameInstructorRequired
              numberOfHoursRequired
              product {
                id
                title
                description
                intro
                orderNumber
                deposit
                pricingMode
                skill {
                  id
                  mssId
                  title
                  description
                }
              }
              article {
                mssId
                title
                description
                size
                sizeUnit
              }
              lessons {
                timeFrom
                timeTo
                mssWorkDayId
              }
              groupCourseDateStart
              groupCourse {
                id
                mobVersion
                appInstance
                mssId
                title
                description
                pointMeetingMssId
                dateFrom
                dateTo
                availableCapacity
                hoursPerDay
                minLength
                schoolSkillLevelClient
                allowGroupCourseFlexibleStart
              }
              groupCourseLessons {
                id
                mobVersion
                appInstance
                mssId
                timeFrom
                timeTo
              }
            }
          }
        }
      }
    }
  }
`;

export const getPayment = /* GraphQL */ `
  query GetPayment($id: ID!) {
    getPayment(id: $id) {
      id
      mobVersion
      groups
      appInstance
      mssId
      paymentMethod
      paymentState
      amount
      currency
      transId
      redirectUrl
      createdAt
      updatedAt
      orderr {
        id
      }
    }
  }
`;

// uspornejsi varianta bez nacitani atributu content, ktery muze byt potencionalne celkem objemny
export const listStaticContentByAppInstance = /* GraphQL */ `
  query ListStaticContentByAppInstance(
    $appInstance: String
    $mobVersion: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelStaticContentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStaticContentByAppInstance(
      appInstance: $appInstance
      mobVersion: $mobVersion
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        title
        icon
        isExternal
        linkUrl
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const createOrderrItem = /* GraphQL */ `
  mutation CreateOrderrItem($input: CreateOrderrItemInput!) {
    createOrderrItem(input: $input) {
      id
    }
  }
`;

export const createOrderrDraft = /* GraphQL */ `
  mutation CreateOrderrDraft($input: CreateOrderrDraftIn!) {
    createOrderrDraft(input: $input) {
      id
    }
  }
`;

export const addToCart = /* GraphQL */ `
  mutation AddToCart($input: AddToCartIn!) {
    addToCart(input: $input) {
      id
    }
  }
`;

export const removeFromCart = /* GraphQL */ `
  mutation RemoveFromCart($orderrItemGroupId: ID!) {
    removeFromCart(orderrItemGroupId: $orderrItemGroupId) {
      id
    }
  }
`;

export const updateOrderrPickupAndPaymentInfo = /* GraphQL */ `
  mutation UpdateOrderrPickupAndPaymentInfo(
    $orderrId: ID!
    $datePickUp: AWSDateTime!
    $paymentMethod: PaymentMethod!
    $dateTryOut: AWSDateTime
    $description: String
  ) {
    updateOrderrPickupAndPaymentInfo(
      orderrId: $orderrId
      datePickUp: $datePickUp
      paymentMethod: $paymentMethod
      dateTryOut: $dateTryOut
      description: $description
    ) {
      id
    }
  }
`;

export const checkoutOrderr = /* GraphQL */ `
  mutation CheckoutOrderr($orderrId: ID!, $subjectIn: SubjectIn!) {
    checkoutOrderr(orderrId: $orderrId, subjectIn: $subjectIn) {
      id
    }
  }
`;

export const applyDiscountCode = /* GraphQL */ `
  mutation ApplyDiscountCode($orderrId: ID!, $code: String!) {
    applyDiscountCode(orderrId: $orderrId, code: $code) {
      id
    }
  }
`;
export const removeDiscountCode = /* GraphQL */ `
  mutation RemoveDiscountCode($orderrId: ID!) {
    removeDiscountCode(orderrId: $orderrId) {
      id
    }
  }
`;
